import React, { useState, useEffect } from 'react';
import CloseButton from '../../../sharecomponents/CloseButton copy';
import Post from '../../../../utils/Post';

/**
 * 
 * @param {function} close funcion de cierre del dialogo
 * @param {object} planID id del paln del que se recuperará el historial
 * @returns 
 */
const HistorialEjecucionesSiembra = (p) => {
    const close = p.close ?? (() => { });
    const [data, setdata] = useState([]);
    const [errorMjs, seterrorMjs] = useState('');
    var mainStyle = {
        position: 'fixed',
        top: '0',
        left: '0',
        zIndex: '9999',
        overflowY: 'auto',
    };
    useEffect(() => {
        if (!p.planID) {
            seterrorMjs('No se ha seleccionado un plan');
            return;
        }
        console.log(`PlanID: ${p.planID}`);
        getHistory(p.planID);
    }, [p.planID]);

    const getHistory = async (id) => {
        let resp = await Post('api/getHistorialSiembra', { planID: id });
        if (!resp.estatus) {
            seterrorMjs(resp.msj);
            return;
        }
        setdata(resp.data);
        console.log(resp.data);
    }

    return (
        <div style={mainStyle} className="vw-100 vh-100 bg-white4 blur-xl p-1">
            <CloseButton close={close} floatElement={true} />
            <div className='row justify-content-center'>
                <div className='w-100 text-center mt-5'>
                    <div className='row justify-content-center'>
                        <div className='bw-800 m-2 p-2 bg-light shadow rounded'>
                            <p className=" h3"><span style={{ fontWeight: 'bold' }}>Eventos de ejecución </span>  {data && data.length > 0 ? data[0].bloque : ""}</p>
                            <p className="h5 opacity-70"><span className='text-bold'>Semana </span>  {data && data.length > 0 ? data[0].semana : ""}</p>
                        </div>
                    </div>
                </div>

                <div className='bw-700 mt-3' style={{ overflow: 'auto' }}>
                    <table className="table table-responsive table-sm table-bordered table-striped mb-3 shadow">
                        <thead>
                            <tr className="">
                                <th className="text-center text-sm border border-orange-900 px-2 py-1">Día reporte</th>
                                <th className="text-center text-sm border border-orange-900 px-2 py-1">Cantidad</th>
                                <th className="text-center text-sm border border-orange-900 px-2 py-1">Usuario</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(data) && data.length > 0 && data.map((h, i) => {
                                return (
                                    <tr key={i}>
                                        <td className="border text-center">{h.dia}</td>
                                        <td className="border text-center">{h.cantidad}</td>
                                        <td className="border text-center">{h.nombre}</td>
                                    </tr>
                                )
                            })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='col-sm-12'></div>
            </div>
        </div>
    )
}

export default HistorialEjecucionesSiembra;